import { Component, Input, OnInit } from "@angular/core";
import { AdminReviewWidgetInfoModalService } from "src/app/shared/services/admin-review-widget-info-modal.service";
import { WidgetsService } from "src/app/shared/services/widgets.service";

@Component({
  selector: 'widget-admin-review',
  templateUrl: './widget-admin-review.component.html',
  styleUrls: ['./widget-admin-review.component.scss']
})
export class WidgetAdminReviewComponent implements OnInit {
  @Input() widgetConfig;

  stageId = null;
  stageName = '';
  isEliminated = false;
  isValid = null;
  loading = false;
  failedToLoad: boolean = false;
  isResultsForParticipantsReleased: boolean = false;
  showFinalComment = false;
  showTurndownReason = false;
  
  constructor(private widgetsService: WidgetsService, private adminReviewInfoModalService: AdminReviewWidgetInfoModalService) { }

  ngOnInit() {
    this.init()
  }

  async init() {
    this.loading = true;
    this.stageId = this.widgetConfig?.widgetSettings?.stageId;
    if (!this.stageId) return;
    try {
      const res: any = await this.widgetsService.getAdminReviewWidgetData(this.stageId).toPromise();
      this.stageName = res.stageName;
      this.isEliminated = res.isEliminated;
      this.isValid = res.isValid;
      this.isResultsForParticipantsReleased = res.isResultsForParticipantsReleased;
      this.showFinalComment = res.hasFinalComment && this.widgetConfig?.widgetSettings?.showFinalComment;
      this.showTurndownReason = res.hasTurndownComment && this.widgetConfig?.widgetSettings?.showTurndownReason;
      this.loading = false;
      this.failedToLoad = false;
    } catch (error) {
      this.loading = false;
      this.failedToLoad = true;
      console.log(error);
    }
  }

  roundTime(days: number) {
    return Math.round(days)
  }

  reloadWidget() {
    this.init();
  }

  async showMoreInfoDialog() {
    const res: any = await this.widgetsService.getAdminReviewWidgetMoreInfo(this.stageId).toPromise();
    this.adminReviewInfoModalService.openAdminReviewWidgetInfoModal(this.stageName, res, this.showFinalComment, this.showTurndownReason);
  }
}
